import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div>
      <h2>404</h2>
      <h2>Page not found</h2>
      <Link to="/main/dashboard">Go to Home</Link>
    </div>
  );
}

export default NotFoundPage;
